export default __webpack_public_path__ + "static/media/flower0875-poster.cfbfd457.jpg";